import React from 'react';
import { Grid } from '@mui/material';
import { usePagination, useSettings } from 'app/main/components';

import PhoneCallsTable from './PhoneCallsTable';
import PhoneCallsChart from './components/PhoneCallsChart';
import PhoneCallsPieChart from './components/PhoneCallsPieChart';

import { type MiddlewhereFilter } from 'app/main/components/filter/FilterItemManager';

export default function PhoneCallsChartTab({ defaultFilters }: { defaultFilters: MiddlewhereFilter[] }) {
	const { t } = useSettings();
	const [refresh, setRefresh] = React.useState(true);
	const updateRefresh = () => setRefresh(state => !state);

	const paginationProps = usePagination({ module: 'phonecalls', filter: { defaultFilters } });

	return (
		<Grid container spacing={2}>
			<Grid size={{ md: 8, xs: 12 }}>
				<PhoneCallsTable
					paginationProps={paginationProps}
					showActions
					showLinkedItem={false}
					refresh={refresh}
					updateRefresh={updateRefresh}
				/>
			</Grid>
			<Grid size={{ md: 4, xs: 12 }}>
				<Grid container spacing={2}>
					<Grid size={{ md: 12, sm: 6, xs: 12 }}>
						<PhoneCallsChart filters={paginationProps.filterProps?.filters} refresh={refresh} />
					</Grid>
					<Grid size={{ md: 12, sm: 6, xs: 12 }}>
						<PhoneCallsPieChart
							title={t('PHONECALLS_PIECHART_DIRECTION_TITLE')}
							filters={paginationProps.filterProps?.filters}
							field="phca_direction"
							formatGroupLabel={({ group }) => t(`PHONECALLS_DIRECTION_${group}`)}
							columns={['phca_duration']}
							refresh={refresh}
						/>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
}
